import { put, takeEvery } from "@redux-saga/core/effects";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
  selectMarketerContract: "[selectMarketerContract] Action",
  selectMarketerContractsList: "[selectMarketerContractsList] Action",
  selectMarketerContractLoad: "[selectMarketerContractLoad] Action",
  selectMarketerContractsListAsync: "[selectMarketerContractsListAsync] Action",
  selectMarketerContractAsync: "[selectMarketerContractAsync] Action",
};

const initialState = {
  data: null, // all contracts (active + history)
  details: null, // single contract info
  loading: false,
};

export const select_marketer_contract = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    // STORE ALL CONTRACTS
    case actionTypes.selectMarketerContract:
      return {
        ...state,
        details: payload?.data ?? null,
      };

    // STORE SINGLE CONTRACT
    case actionTypes.selectMarketerContractsList:
      return {
        ...state,
        data: payload?.data ?? null,
      };

    // LOADING DETAILS
    case actionTypes.selectMarketerContractLoad:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectMarketerContractLoad,
    payload: payload,
  });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "select_marketer_contract",
    data: payload?.data ? payload?.data : {},
    sort_by: {},
    size: "50",
    from: "0",
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    yield put({
      type: actionTypes.selectMarketerContractsList,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({
      type: actionTypes.selectMarketerContractLoad,
      payload: false,
    });
  }
}

function* handleWorkerDetails({ payload }) {
  yield put({
    type: actionTypes.selectMarketerContractLoad,
    payload: true,
  });

  const config = { url: "select_request" };
  const data = {
    table: "marketer",
    method_type: "select_marketer_contract",
    data: payload || {}, // ID or filters sent here
    sort_by: {},
    size: "50",
    from: "0",
  };

  try {
    let res = yield AxiosCustom(config, data);
    handleNotificationAlertTrySelect(res);

    yield put({
      type: actionTypes.selectMarketerContract,
      payload: res.data.response,
    });
  } catch (err) {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectMarketerContractLoad,
      payload: false,
    });
  }
}

export function* selectMarketerContract() {
  yield takeEvery(actionTypes.selectMarketerContractsListAsync, handleWorker);
  yield takeEvery(actionTypes.selectMarketerContractAsync, handleWorkerDetails);
}
